module.exports = __webpack_public_path__ + "img/article-2-5.1a5b81f0.png";